import { ChangeDetectionStrategy, Component, inject, input, viewChild } from '@angular/core'
import { FormControl, NgControl, ReactiveFormsModule, Validators } from '@angular/forms'
import { ShoeOrderItem } from '../../../../../domain/order.model'
import {
	ControlMultiplierComponent,
	ControlTemplateDirective,
} from '../../modules/form/control-multiplier/control-multiplier.component'
import { ControlValueAccessor } from '../../modules/form/core/control-value-accessor'
import { FmxControlSubmitDirective } from '../../modules/form/submit/control-submit.directive'
import { CartOrderItemFormComponent } from './cart-order-item-form.component'
import { AppUserCurrency } from '../../../../../domain/price-categories'

@Component({
	selector: 'app-cart-order-items-form',
	template: `
		<app-control-multiplier [formControl]="control">
			<ng-template appControlTemplate let-ctrl>
				<app-cart-order-item-form
					[formControl]="ctrl"
					[currency]="currency()"
					(objectRemove)="removeControl($event)"
				></app-cart-order-item-form>
			</ng-template>
		</app-control-multiplier>
	`,
	styleUrls: ['./shared-cart-shoe-order-item-form-styles.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		ControlMultiplierComponent,
		ReactiveFormsModule,
		FmxControlSubmitDirective,
		ControlTemplateDirective,
		CartOrderItemFormComponent,
	],
})
export class CartOrderItemsFormComponent extends ControlValueAccessor<Array<ShoeOrderItem>> {
	protected readonly ngControl: NgControl
	readonly control = new FormControl<Array<ShoeOrderItem>>([], { nonNullable: true, validators: [Validators.required] })

	private readonly controlMultiplier = viewChild.required(ControlMultiplierComponent<ShoeOrderItem>)

	readonly currency = input.required<AppUserCurrency>()

	constructor() {
		const ngControl = inject<NgControl>(NgControl)
		super(ngControl)
		this.ngControl = ngControl
	}

	removeControl(shoeOrderId: string) {
		this.controlMultiplier().removeBy((shoeOrder: any) => shoeOrder.id === shoeOrderId)
	}
}
